module.exports = __webpack_public_path__ + "images/product-icon-3-years-warranty-on-parts-and-labour.735369.svg";